import React, { useContext } from 'react';
import classNames from 'classnames';
import { StepToParam } from '@/api/appSolutionBuilder/search';
import { AppSolutionBuilderStep } from '@/api/appSolutionBuilder/types';
import DefaultImage from '@/assets/images/defaultImage.jpg';
import { AvatarLink } from '@/components/shared';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetCustomerSegments } from '@/generated/customer-segment';
import { Area, PageType } from '@/generated/data.schemas';
import { useGetLayout } from '@/generated/layout';
import { useGetTranslations } from '@/generated/translations';
import styles from './SegmentBar.module.scss';

interface SegmentBarProps {
	closeDrawer?: () => void;
}

export const SegmentBar: React.FunctionComponent<SegmentBarProps> = ({ closeDrawer }) => {
	const { segmentationId } = useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);
	const { data: layout } = useGetLayout(segmentationId);
	const { data: segments, isLoading } = useGetCustomerSegments(segmentationId);

	const staticLinks = layout?.data.staticLinks;
	const appSolutionBuilderLink =
		staticLinks?.find((item) => item.pageType === PageType.AppSolutionBuilder)?.url || '';

	return (
		<section className={styles.wrapper}>
			<h2 className={styles.title}>{translations?.data.shared.navigation.segmentBarTitle}</h2>

			<ul className={styles.segmentList}>
				{isLoading ? (
					<li className={'u-mb-xl'}>
						<div className={classNames(styles.spinner, 'u-spinner')} />
					</li>
				) : (
					segments?.data.map((segment, index) => {
						const externalRoute = `${appSolutionBuilderLink}?${StepToParam[AppSolutionBuilderStep.Segment]}=${segment.id}`;
						const image = {
							url: segment.icon?.url ?? DefaultImage,
							width: segment.icon?.width,
							height: segment.icon?.height,
						};
						return (
							<li key={index} className={styles.segmentItem}>
								<AvatarLink
									className={styles.segmentLink}
									image={{
										size180: image,
										size320: image,
										size480: image,
										size720: image,
										size960: image,
										size1280: image,
										size1920: image,
										altText: segment.icon?.altText,
									}}
									linkTitle={segment.name}
									to={externalRoute}
									route={{
										area: Area.StaticPages,
										pageType: PageType.AppSolutionBuilder,
										externalRoute,
									}}
									onClick={closeDrawer}
								/>
							</li>
						);
					})
				)}
			</ul>
		</section>
	);
};
